export class UserDataMissingException extends Error {
  constructor() {
    super(
      'User data is missing. Make sure to call loginWithPassword before calling this method.',
    );
  }
}
